// extracted by mini-css-extract-plugin
export var button = "buttons-module--button--2TlJs";
export var disabled = "buttons-module--disabled--3alIh";
export var buttonBorder = "buttons-module--buttonBorder--1Px1D";
export var buttonGroup = "buttons-module--button-group--3dTI-";